import { createReducer, on, createFeature } from '@ngrx/store'
import * as CountryActions from './country.actions'
import { CountryState } from './country.state'

const initialState: CountryState = {
  countries: [],
  selectedCountry: null,
  loading: false,
  error: null
}

export const countryReducer = createReducer(
  initialState,
  on(CountryActions.loadCountries, state => ({ ...state, loading: true })),
  on(CountryActions.loadCountriesSuccess, (state, { countries }) => ({
    ...state,
    countries,
    loading: false,
    error: null
  })),
  on(CountryActions.loadCountryByStateSuccess, (state, { country }) => ({
    ...state,
    selectedCountry: country,
    loading: false,
    error: null
  })),
  on(CountryActions.loadCountryFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  }))
)

// Create the feature for the business state
export const countryFeature = createFeature({
  name: 'country', // Feature name
  reducer: countryReducer
})
export type { CountryState }
// Export the feature's selectors
export const { name, reducer, selectCountries, selectLoading, selectError } = countryFeature
